module.exports = __webpack_public_path__ + "img/p258.283ac476.png";